import { createCancellationOverviewMachine } from '@eneco/flows/machines';

export const overviewMachine = createCancellationOverviewMachine('toonservice');
